import { useCallback, useEffect, useState } from "react";
import { PppoeUserService } from "../services/PppoeUserService";
import { PiutangService } from "../services/PiutangService";

export const useHookPiutang = () => {
    const [data, setData] = useState([]);
    const [meta, setMeta] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [params, setParams] = useState({
        search: "",
        page: 1,
        limit: 10,
    })


    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const res = await PiutangService.get({params:params});

            const result = res?.data?.data ?? [];

            setData(Array.isArray(result) ? result : []);
            setMeta(res?.data?.meta);
        } catch (err) {
            console.error(err);
            setError(err?.response?.data || err);
        } finally {
            setLoading(false);
        }
    }, [params]);

    useEffect(() => {
        getData();
    }, [getData]);

    return {
        data,
        meta,
        loading,
        error,

        params,
        setParams,

        refreshData: getData,
    };
};